import { LOGIN_SUCCESS, RESET_STORE } from './constants';
import { login, passwordReset } from 'api/users';
import { encode, decode } from 'utilities';
import { TOKEN_NAME, USER_ITEM_NAME } from 'CONSTANTS';

export const resetStore = () => ({
  type: RESET_STORE,
});

export const loginSuccess = user => ({
  type: LOGIN_SUCCESS,
  user
});

const createUser = function(data) {
  return {
    ...data,
    initials: (data.first_name.substring(0,1) + data.last_name.substring(0,1)).toUpperCase(),
    full_name: `${data.first_name} ${data.last_name}`
  };
}

export const loginWorker = credentials => async (dispatch):Promise<any> => {
  try {
    const { payload } = await login(credentials);

    const user = createUser(payload);

    localStorage.setItem(USER_ITEM_NAME, encode(JSON.stringify(user)));
    localStorage.setItem(TOKEN_NAME, payload.token);
    dispatch(loginSuccess(user));
    return Promise.resolve(payload);
  } catch(err) {
    return Promise.reject(err);
  }
};

export const logoutWorker = () => (dispatch):Promise<any> => {
  localStorage.removeItem(TOKEN_NAME);
  localStorage.removeItem(USER_ITEM_NAME);
  dispatch(resetStore());
  return Promise.resolve();
};

export const authInitWorker = () => (dispatch):void => {
  if(localStorage[USER_ITEM_NAME]) {
    dispatch(loginSuccess(JSON.parse(decode(localStorage[USER_ITEM_NAME]))));
  }
}

export const updateUserWorker = user => (dispatch, getState) => {
  const state = getState().auth.user;
  localStorage.removeItem(USER_ITEM_NAME);

  const newUser = createUser({ ...state, ...user });

  localStorage.setItem(USER_ITEM_NAME, encode(JSON.stringify(newUser)));

  dispatch(loginSuccess(newUser));
  return Promise.resolve(newUser);
};

export const passwordResetWorker = data => async (dispatch):Promise<any> => {
  try {
    const { payload } = await passwordReset(data);
    return Promise.resolve(payload);
  } catch(err) {
    return Promise.reject(err);
  }
};


// WEBPACK FOOTER //
// ./src/ducks/auth/actions.js